import "./App.css";
import Main from "./pages/Main";

function App() {
  return (
    // <Header />
    <Main/>
  );
}

export default App;
